var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-solid 1",
    clipPath: "url(#clip0_351_66364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.213 -0.080719L10.6068 1.43178L14.921 5.49428L16.5272 3.98178C17.3568 3.20053 17.3568 1.93491 16.5272 1.15366L15.2197 -0.080719C14.39 -0.861969 13.046 -0.861969 12.2164 -0.080719H12.213ZM9.85684 2.13803L2.12122 9.42553C1.77609 9.75053 1.52387 10.1537 1.38449 10.5943L0.209714 14.3537C0.126749 14.6193 0.203076 14.9037 0.408829 15.0974C0.614581 15.2912 0.916572 15.363 1.19533 15.288L5.18759 14.1818C5.65551 14.0505 6.08361 13.813 6.42874 13.488L14.171 6.20053L9.85684 2.13803Z",
    fill: "#BBC2C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_66364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9911,
    height: 16,
    fill: "white",
    transform: "translate(0.176758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/edit_image.5227549d9fe4988006c5c6f5c1c11415.svg";
export { ForwardRef as ReactComponent };